(function () {
  'use strict';

  if (window.PGMarketCartV62Installed) return;
  window.PGMarketCartV62Installed = true;

  var config = window.PGMarketCartV62 || {};
  var threshold = Number.isFinite(Number(config.threshold)) ? Number(config.threshold) : 7000;
  var currency = String(config.currency || 'GBP');
  var saleEnd = String(config.saleEnd || '');
  var cartTimer = null;
  var uiTimer = null;
  var observer = null;
  var lastCompleteSetMount = null;
  var nativeAlert = window.alert ? window.alert.bind(window) : null;

  function marketCountry() {
    return String(config.country || '').toUpperCase();
  }

  function isUK() {
    var country = marketCountry();
    return country === 'GB' || country === 'UK';
  }

  function isUS() {
    return marketCountry() === 'US';
  }

  function shopRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function money(cents, compact) {
    var value = Number(cents || 0);
    var whole = value % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: compact && whole ? 0 : 2,
        maximumFractionDigits: compact && whole ? 0 : 2
      }).format(value / 100);
    } catch (error) {
      var symbol = currency === 'USD' ? '$' : '£';
      return symbol + (value / 100).toFixed(compact && whole ? 0 : 2);
    }
  }

  function setHtml(node, value) {
    if (node && node.innerHTML !== value) node.innerHTML = value;
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function replaceLooseText(node, value) {
    if (!node) return;
    var textNode = Array.prototype.find.call(node.childNodes, function (child) {
      return child.nodeType === 3 && String(child.nodeValue || '').trim();
    });
    if (textNode) {
      if (String(textNode.nodeValue || '').trim() !== value) textNode.nodeValue = ' ' + value;
    } else {
      node.appendChild(document.createTextNode(' ' + value));
    }
  }

  function applyCart(cart) {
    if (!cart || !Number.isFinite(Number(cart.total_price))) return;
    if (cart.currency) currency = String(cart.currency);

    var total = Number(cart.total_price || 0);
    var remaining = Math.max(0, threshold - total);
    var pct = threshold > 0 ? Math.min(100, Math.round(total / threshold * 100)) : 100;

    if (isUK() || isUS()) {
      var includedShippingLabel = isUS() ? 'Free US shipping' : 'Free UK shipping';
      document.querySelectorAll('.pg-drawer-shipbar__text').forEach(function (node) {
        setHtml(node, '<strong>' + includedShippingLabel + '</strong>');
      });
      document.querySelectorAll('.pg-drawer-shipbar__fill').forEach(function (node) {
        if (node.style.width !== '100%') node.style.width = '100%';
      });

      var includedCartText = document.querySelector('.pg-cart__shipbar-text');
      if (includedCartText) setHtml(includedCartText, '<span class="pg-rose-text">' + includedShippingLabel + '</span>');
      var includedFullFill = document.querySelector('.pg-cart__progress-fill');
      if (includedFullFill && includedFullFill.style.width !== '100%') includedFullFill.style.width = '100%';
      setText(document.querySelector('.pg-cart__progress-cap'), 'Included');
      var includedProgress = document.querySelector('.pg-cart__progress');
      if (includedProgress) includedProgress.setAttribute('aria-valuenow', '100');
      return;
    }

    var drawerCopy = remaining > 0
      ? '<strong>' + money(remaining, true) + '</strong> away from FREE delivery'
      : 'You’ve unlocked <strong>FREE delivery</strong>! 🎉';

    document.querySelectorAll('.pg-drawer-shipbar__text').forEach(function (node) {
      setHtml(node, drawerCopy);
    });
    document.querySelectorAll('.pg-drawer-shipbar__fill').forEach(function (node) {
      var width = pct + '%';
      if (node.style.width !== width) node.style.width = width;
    });

    var cartText = document.querySelector('.pg-cart__shipbar-text');
    if (cartText) {
      var fullCopy = remaining > 0
        ? 'Add <strong>' + money(remaining, true) + '</strong> more for <span class="pg-rose-text">FREE</span> delivery'
        : 'You’ve unlocked <span class="pg-rose-text">FREE</span> delivery! 🎉';
      setHtml(cartText, fullCopy);
    }

    var fullFill = document.querySelector('.pg-cart__progress-fill');
    if (fullFill && fullFill.style.width !== pct + '%') fullFill.style.width = pct + '%';
    setText(document.querySelector('.pg-cart__progress-cap'), money(threshold, true));
    var progress = document.querySelector('.pg-cart__progress');
    if (progress) progress.setAttribute('aria-valuenow', String(pct));
  }

  function refreshCart() {
    cartTimer = null;
    fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(applyCart)
      .catch(function () {});
  }

  function scheduleCart(delay) {
    window.clearTimeout(cartTimer);
    cartTimer = window.setTimeout(refreshCart, delay == null ? 50 : delay);
  }

  function productData() {
    var wrapper = document.querySelector('[data-product-form]');
    if (!wrapper) return null;
    try { return JSON.parse(wrapper.getAttribute('data-product') || 'null'); }
    catch (error) { return null; }
  }

  function currentVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var select = document.querySelector('[data-product-form] select[data-variants], select[data-variants]');
    if (!select) return product.variants[0];
    var id = Number(select.value || 0);
    return product.variants.find(function (variant) { return Number(variant.id) === id; }) || product.variants[0];
  }

  function applyProductCommerce() {
    var product = productData();
    var variant = currentVariant(product);
    if (variant) {
      var remaining = Math.max(0, threshold - Number(variant.price || 0));
      var cfgLine = document.querySelector('.pg-cfg-shipline');
      var stickyLine = document.querySelector('.pg-sticky-atc__shipline');
      if (isUK() || isUS()) {
        var productShippingLabel = isUS() ? 'Free US shipping on all orders' : 'Free UK shipping';
        setHtml(cfgLine, '<strong>' + productShippingLabel + '</strong>');
        setText(stickyLine, productShippingLabel);
      } else if (Number(variant.price || 0) >= threshold) {
        setHtml(cfgLine, 'Congrats! You’ve earned <strong>FREE SHIPPING</strong>');
        setText(stickyLine, 'You’ve unlocked free shipping');
      } else {
        setHtml(cfgLine, money(remaining, true) + ' away from <strong>FREE shipping</strong>');
        setText(stickyLine, 'Free shipping over ' + money(threshold, true));
      }
    }

    var proofStrong = document.querySelector('.pg-cfg-proof strong');
    setText(proofStrong, '2–3 working days');

    var timer = document.querySelector('.pg-product-sale-timer');
    if (timer && saleEnd) {
      if (timer.getAttribute('data-pg-sale-end') !== saleEnd) timer.setAttribute('data-pg-sale-end', saleEnd);
      var count = timer.querySelector('.pg-product-sale-timer__count');
      var end = new Date(saleEnd).getTime();
      var distance = end - Date.now();
      if (count && Number.isFinite(end) && distance > 0) {
        var days = Math.floor(distance / 86400000);
        var hours = Math.floor(distance / 3600000 % 24);
        var minutes = Math.floor(distance / 60000 % 60);
        setText(count, days + 'd ' + hours + 'h ' + minutes + 'm');
      }
    }
  }

  function applyMarketCopy() {
    var country = marketCountry();
    if (isUK()) {
      document.querySelectorAll('.pibb__item').forEach(function (item) {
        var heading = item.querySelector('.pibb__heading');
        if (!heading) return;
        var title = heading.textContent.trim();
        if (title === 'Free UK Delivery' || title === 'Free UK Shipping') {
          setText(heading, 'Free UK Shipping');
          setText(item.querySelector('.pibb__body'), 'On all orders');
          var link = item.querySelector('.pibb__card[aria-label]');
          if (link) link.setAttribute('aria-label', 'Free UK Shipping');
        } else if (title === 'Proof Before Print') {
          setText(item.querySelector('.pibb__body'), 'Artwork proof in 2–3 working days');
        }
      });

      document.querySelectorAll('.pg-cart__trust-item').forEach(function (item) {
        var heading = item.querySelector('strong');
        if (!heading || !/^Free UK (Delivery|Shipping)$/i.test(heading.textContent.trim())) return;
        setText(heading, 'Free UK Shipping');
        setText(item.querySelector('.pg-cart__trust-sub'), '');
      });

      document.querySelectorAll('.pg-extras__trust-item').forEach(function (item) {
        if (/free uk delivery/i.test(item.textContent || '')) replaceLooseText(item, 'Free UK shipping');
      });

      document.querySelectorAll('span').forEach(function (node) {
        var text = String(node.textContent || '').replace(/\s+/g, ' ').trim();
        if (text === 'Free Delivery Over £70 / $95' || text === 'Free Shipping Over £70 / $95' || text === 'Free Delivery Over £70' || text === 'Free Shipping Over £70') {
          setText(node, 'Free UK Shipping');
        }
      });
    } else if (country === 'US') {
      document.querySelectorAll('.pibb__item').forEach(function (item) {
        var heading = item.querySelector('.pibb__heading');
        if (!heading) return;
        var title = heading.textContent.trim();
        if (/^Free UK (Delivery|Shipping)$/i.test(title)) {
          setText(heading, 'Free US Shipping');
          setText(item.querySelector('.pibb__body'), 'On all orders');
          var link = item.querySelector('.pibb__card[aria-label]');
          if (link) link.setAttribute('aria-label', 'Free US Shipping');
        } else if (title === 'Proof Before Print') {
          setText(item.querySelector('.pibb__body'), 'Artwork proof in 2–3 working days');
        }
      });

      document.querySelectorAll('.pg-cart__trust-item').forEach(function (item) {
        var heading = item.querySelector('strong');
        if (!heading || !/^Free UK (Delivery|Shipping)$/i.test(heading.textContent.trim())) return;
        setText(heading, 'Free US Shipping');
        setText(item.querySelector('.pg-cart__trust-sub'), 'On all orders');
      });

      document.querySelectorAll('.pg-extras__trust-item').forEach(function (item) {
        if (/free uk (delivery|shipping)/i.test(item.textContent || '')) replaceLooseText(item, 'Free US shipping on all orders');
      });
    }

    var shippingProof = document.querySelector('.pg-shipping-page__timeline article:first-child p');
    setText(shippingProof, 'Your artwork proof is usually sent within 2–3 working days. During busy periods, please allow 3–5 working days. You can approve it or request edits.');
  }

  function showCompleteSetStatus(message) {
    var mount = lastCompleteSetMount;
    if (!mount || !mount.isConnected) mount = document.querySelector('[data-pg-complete-set-mount]');
    var status = mount && mount.querySelector('.pg-complete-set__discount-status');
    if (!status) return false;
    setText(status, message);
    status.classList.add('is-error');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    return true;
  }

  function installAlertGuard() {
    if (!nativeAlert || window.PGCompleteSetAlertGuardV62) return;
    window.PGCompleteSetAlertGuardV62 = true;
    window.alert = function (message) {
      var text = String(message || '');
      var isCompleteSet = /matching add-on|not eligible for that matching add-on|already in your cart|matching add-on could not be added/i.test(text);
      if (isCompleteSet && showCompleteSetStatus(text)) return;
      return nativeAlert(message);
    };
  }

  function applyUi() {
    uiTimer = null;
    applyProductCommerce();
    applyMarketCopy();
  }

  function scheduleUi(delay) {
    window.clearTimeout(uiTimer);
    uiTimer = window.setTimeout(applyUi, delay == null ? 0 : delay);
  }

  function boot() {
    installAlertGuard();
    applyUi();
    refreshCart();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-product-form]')) scheduleUi(0);
    }, true);

    document.addEventListener('click', function (event) {
      var completeSetButton = event.target && event.target.closest && event.target.closest('[data-pg-complete-set-add]');
      if (completeSetButton) {
        lastCompleteSetMount = completeSetButton.closest('[data-pg-complete-set-mount]');
        var status = lastCompleteSetMount && lastCompleteSetMount.querySelector('.pg-complete-set__discount-status');
        if (status) status.classList.remove('is-error');
      }
      if (event.target && event.target.closest && event.target.closest('.cart_content, #pg-cart')) scheduleCart(100);
      scheduleUi(30);
    }, true);

    document.addEventListener('cart:refresh', function () { scheduleCart(20); scheduleUi(30); });
    document.addEventListener('shopify:cart:lines-update', function () { scheduleCart(20); scheduleUi(30); });
    document.addEventListener('pg:cart-form-patched', function () { scheduleCart(20); scheduleUi(30); });
    document.addEventListener('shopify:section:load', function () { scheduleUi(0); scheduleCart(50); });

    if (window.MutationObserver && document.body) {
      observer = new MutationObserver(function (mutations) {
        var needsUi = false;
        var needsCart = false;
        mutations.forEach(function (mutation) {
          var target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target && mutation.target.parentElement;
          if (!target || !target.closest) return;
          if (target.closest('.pg-cfg-footer, .pg-sticky-atc, .pibb__item, .pg-cart__trust-item, .pg-shipping-page, [data-pg-complete-set-mount], #new_announce, .announce-bar')) needsUi = true;
          if (target.closest('.cart_content, #pg-cart')) needsCart = true;
        });
        if (needsUi) scheduleUi(0);
        if (needsCart) scheduleCart(40);
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    [250, 800, 1800, 3500].forEach(function (delay) {
      window.setTimeout(applyUi, delay);
    });
    [300, 1200, 3000].forEach(function (delay) {
      window.setTimeout(refreshCart, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
